import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Error } from '../error';
import { Button } from '../input';
import { Modal } from '../modal';
import { useGlobal } from '../../state';
import { Code } from './Code';

export const Inner = ({
  blurb,
  examples,
  initialParams,
  inlineResults,
  required,
  endpoint,
  disabled,
  attach,
  renderChildren,

  onRun,
  onSubmit,
  onErrors,

  onStart,
  onJob,
  onFinished,
}) => {
  const navigate = useNavigate();
  const { fox, apiKey } = useGlobal();
  const [params, setParams] = useState(initialParams || {});
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState();
  const [missing, setMissing] = useState(false);

  const intervalRef = useRef();

  useEffect(() => {
    const m = required.map((it) => params[it]).filter((it) => it === undefined || it === null);
    setMissing(m.length > 0);
  }, [required, params]);

  const handleChange = (field, value) => {
    console.log('handleChange', params, field, value);

    const copy = JSON.parse(JSON.stringify(params));
    copy[field] = value;

    for (const key of Object.keys(copy)) {
      const val = copy[key];
      if (val === null || val === undefined || val === '') {
        delete copy[key];
      }
    }

    setParams(copy);
  };

  const handleSubmit = async (e) => {
    if (onStart) {
      onStart();
    }

    if (!apiKey) {
      return;
    }

    setLoading(true);
    setErrors(null);

    try {
      const handleFinished = (out) => {
        clearInterval(intervalRef.current);
        if (onFinished) {
          onFinished(out);
        }
      };

      const handleJob = (job) => {
        if (onJob) {
          onJob(job);
        }
      };

      const copy = JSON.parse(JSON.stringify(params));

      if (endpoint == 'visit') {
        copy.include ||= [];
        copy.include.push('timer');

        if ((copy.urls || [])?.length == 1) {
          copy.url = copy.urls[0];
          delete copy.urls;
        }
      }

      if (attach) {
        const results = await await fox[endpoint](copy);
        console.log('results from attached:', results);
        const out = { name: endpoint, ...results };
        handleJob(out);
        handleFinished(out);
      } else {
        const job = await fox[endpoint].detach(copy);
        handleJob(job);

        if (!inlineResults) {
          // navigate(0);
          navigate('/jobs/' + job.id);
        } else {
          job.on('finished', handleFinished);
        }
        if (onRun) {
          await onRun(job);
        }
      }
    } catch (e) {
      console.error('Error while running:', e);
      setErrors(e.errors);

      if (onFinished) {
        onFinished({ errors: e.errors });
      }
    } finally {
      setLoading(false);
    }

    return;

    // if (onSubmit) {
    //   onSubmit();
    // }

    // setLoading(true);
    // setErrors(null);

    // console.log('Run', fox, endpoint, params);
    // try {
    //   if (true) {
    //     const job = await fox[endpoint].detach(params);
    //     console.log('Detached job', job);
    //     if (!inlineResults) {
    //       navigate('/jobs/' + job.id);
    //     } else {
    //       job.on('finished', () => {
    //         setLoading(false);
    //       });
    //     }
    //     if (onRun) {
    //       await onRun(job);
    //     }

    //   } else {
    //     console.log('Run attached');
    //     const results = await await fox[endpoint](params);
    //     console.log('Attached results:', results);
    //     onRun(results);
    //   }
    // } catch (e) {
    //   console.error('Error while running:', e);
    //   setErrors(e.errors);
    //   setLoading(false);

    //   if (onErrors) {
    //     onErrors(e.errors);
    //   }
    // }
  };

  const examplesNode = (
    <div style={{ fontSize: 12, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
      <div>Fill example:</div>
      <div style={{ display: 'flex', gap: 10 }}>
        {(examples || []).map((it, idx) => (
          <Button key={idx} small trans black onClick={() => setParams({ ...initialParams, ...params, ...it.params })}>
            {it.name}
          </Button>
        ))}
      </div>
    </div>
  );

  return (
    <div>
      {!!examples?.length && examplesNode}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {renderChildren(params, handleChange, setParams, errors)}

        <div style={{ display: 'flex', gap: 10 }}>
          <Button
            disabled={missing || disabled || loading}
            loading={loading}
            style={{ width: 180, marginTop: 5 }}
            onClick={handleSubmit}
          >
            Run
          </Button>

          <Modal title={`Code snippet for ${endpoint}`}>
            <Button
              style={{ width: 180, marginTop: 5 }}
              flat
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              Get Code
            </Button>
            <div>
              <Code endpoint={endpoint} params={params} />
            </div>
          </Modal>
        </div>

        {errors && <Error small message="Check errors above" />}
        {/*
        <pre>{JSON.stringify(errors, null, 2)}</pre>
        <pre>{JSON.stringify(params, null, 2)}</pre>
        INNER INITIAL:<pre>{JSON.stringify(initialParams, null, 2)}</pre>
        */}
      </div>
    </div>
  );
};
